export { default } from './OutlinedInput';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/OutlinedInput/index.js
// module id = 459
// module chunks = 121